export default __webpack_public_path__ + "static/media/IMG-20240708-WA0006.ec576b89.jpg";